import { defaultPrinterSettings, electronPrintSettingsSlice } from '@store/slices/electronPrintSettings';
import { useAppDispatch, useAppSelector } from '..';
import { ElectronPrintSettings } from '@interfaces/general';

export const useElectronPrintSettingsFromStore = () => {
  return useAppSelector((state) => state.electronPrintSettings);
};

// Impresora "principal" para acciones de impresión MANUAL (botones de imprimir
// pedido) y para flags de auto-print de pantalla. Reemplaza el acceso fijo a
// `.Printer1`, que se rompía con el modelo flexible al quitar esa impresora.
// Preferencia: primera habilitada con impresora asignada → primera habilitada →
// primera de la lista. Nunca undefined (el store garantiza ≥1; default defensivo).
export const useMainPrinter = (): ElectronPrintSettings => {
  const all = useElectronPrintSettingsFromStore();
  const keys = Object.keys(all);
  if (!keys.length) return defaultPrinterSettings();
  const withPrinter = keys.find((k) => all[k].electronEnabled !== false && all[k].electronPrinterName);
  const enabled = keys.find((k) => all[k].electronEnabled !== false);
  return all[withPrinter || enabled || keys[0]];
};

export const useElectronPrintSettingsActions = () => {
  const dispatch = useAppDispatch();

  // printerKey es un id dinámico (modelo flexible). V1 sigue pasando 'Printer1'…
  // que son strings → compatible.
  const updateElectronPrintSettings = (settings: Partial<ElectronPrintSettings>, printerKey: string) =>
    dispatch(electronPrintSettingsSlice.actions.updateElectronPrintSettings({ settings, printerKey }));

  const addPrinter = (patch?: Partial<ElectronPrintSettings>) =>
    dispatch(electronPrintSettingsSlice.actions.addPrinter(patch ? { patch } : undefined));

  const removePrinter = (printerKey: string) =>
    dispatch(electronPrintSettingsSlice.actions.removePrinter({ printerKey }));

  const resetPrinters = () => dispatch(electronPrintSettingsSlice.actions.reset());

  return { updateElectronPrintSettings, addPrinter, removePrinter, resetPrinters };
};
